import * as prismic from "@prismicio/client";
import * as prismicNext from "@prismicio/next";
import config from "./prismic.config.json";

/**
 * The project's Prismic repository name.
 */
export const repositoryName = process.env.NEXT_PUBLIC_PRISMIC_ENVIRONMENT || config.repositoryName;

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
// TODO: Update the routes array to match your project's route structure.
export const routes: prismic.ClientConfig["routes"] = [
  {
    type: "homepage",
    path: "/:lang",
  },
  {
    type: "product",
    path: "/:lang/produits/:uid",
  },
  {
    type: "page",
    path: "/:lang/:uid",
  },
  {
    type: "tables",
    path: "/:lang/tables/:uid",
  },
  {
    type: "inspiration",
    path: "/:lang/inspiration/:uid",
  },
  {
    type: "inspiration_category",
    path: "/:lang/categorie-inspiration/:uid",
  },
  {
    type: "archive_inspiration",
    path: "/:lang/inspiration",
  },
  {
    type: "archive_table",
    path: "/:lang/tables",
  },
  {
    type: "faq",
    path: "/:lang/faq/:uid",
  },
  {
    type: "tag",
    path: "/:lang/tag/:uid",
  },
  {
    type: "categorie",
    path: "/:lang/categories/:uid",
  },
  {
    type: "contact",
    path: "/:lang/contact",
  },
];

export const staticRoutes = [
  {
    type: "account",
    path: "/:lang/:uid/:action",
  },
];

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const createClient = (config: prismicNext.CreateClientConfig = {}) => {
  const client = prismic.createClient(repositoryName, {
    routes,
    fetchOptions:
      process.env.NODE_ENV === "production"
        ? { next: { tags: ["prismic"] }, cache: "force-cache" }
        : { next: { revalidate: 5 } },
    ...config,
  });

  prismicNext.enableAutoPreviews({
    client,
  });

  return client;
};
